import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  input,
  signal,
} from '@angular/core';
import { LinkIconComponent, CheckIconComponent } from '@kuiper/icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { delay, of } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'lib-copy-link',
  imports: [LinkIconComponent, TranslocoPipe, CheckIconComponent],
  templateUrl: './copy-link.component.html',
  styleUrl: './copy-link.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CopyLinkComponent {
  private readonly el = inject(ElementRef);
  private readonly destroyRef = inject(DestroyRef);

  clickableLinkTitle = input<string>();
  linkDescription = input<string>();
  urlNavigation = input<string>('');

  tooltipVisible = signal(false);
  tooltipStyle = signal<{ top: string; left: string }>({
    top: '0px',
    left: '0px',
  });

  isCopied = signal(false);

  showTooltip() {
    const btn = this.el.nativeElement.querySelector('button');
    const rect = btn.getBoundingClientRect();
    const rootFontSize = Number.parseFloat(
      getComputedStyle(document.documentElement).fontSize
    );
    this.tooltipStyle.set({
      top: `${rect.top / rootFontSize}rem`,
      left: `${(rect.left + rect.width / 2) / rootFontSize}rem`,
    });
    this.tooltipVisible.set(true);
  }

  hideTooltip() {
    this.tooltipVisible.set(false);
  }

  copyLink() {
    const url = this.urlNavigation() || globalThis.location.href;
    const html = `<a href="${url}" target="_blank">${this.clickableLinkTitle()}</a> : ${this.linkDescription()}`;

    const data = [
      new ClipboardItem({
        'text/plain': new Blob([url], { type: 'text/plain' }),
        'text/html': new Blob([html], { type: 'text/html' }),
      }),
    ];

    navigator.clipboard.write(data);

    this.isCopied.set(true);
    of(null)
      .pipe(takeUntilDestroyed(this.destroyRef), delay(1500))
      .subscribe(() => this.isCopied.set(false));
  }
}
